import { createTheme, ThemeProvider } from '@mui/material';
import './App.css';
import Routing from './routers/Routing';
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useEffect, useState } from 'react';


function App() {
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  // Define your custom theme colors here
  const theme = createTheme({
    palette: {
      primary: {
        main: '#4CAF50', // Custom primary color
      },
      secondary: {
        main: '#1976d2', // Custom secondary color
      },
    },
  });

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    // Adding event listeners
    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    // Cleanup the event listeners when component is unmounted
    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  return (
    <>
      {
        isOnline ? (
          <ThemeProvider theme={theme}>
            <div className="App">
              <Routing />
              <ToastContainer autoClose={2000} />
            </div>
          </ThemeProvider>
        ) : (
          <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh',
            backgroundColor: '#f4f4f4', // Optional background color for offline screen
          }}>
           
            <span style={{
              backgroundColor: 'red',
              color: 'white',
              padding: '20px',
              textAlign: 'center',
              fontSize: '16px',
              borderRadius: '5px',
            }}>
              You are currently offline. Please check your network connection.
            </span>
          </div>
        )
      }
    </>
  );
}

export default App;
